import React, { useRef } from "react";
import { useSelector } from "react-redux";
import ChartName from "../../Dashboard/Charts/ChartName";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import TopTopicsChart from "../../Dashboard/Charts/TopTopics/TopTopicsChart";
import { Dimmer, Loader, Icon } from "semantic-ui-react";
import moment from "moment";
import { QuestionLists } from "../HomePage/Header/InsightsTabComponent";

const TopTopics = () => {
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const topic1Data = useSelector((state) => state.insightsRecommendationReducer.chartData?.["top-topics"]?.own);
    const topic1DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading?.["top-topics"]?.own);
    const topic2Data = useSelector((state) => state.insightsRecommendationReducer.chartData["top-topics"]?.competitor);
    const topic2DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading["top-topics"]?.competitor);
    const currentPage = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    let widgetContainerRef1 = useRef(null);
    let widgetContainerRef2 = useRef(null);
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    let range = moment().tz(tz).subtract(7, "days").format("DD-MM-YYYY") + ` to ` + moment().tz(tz).subtract(1, "days").format("DD-MM-YYYY");
    let question = QuestionLists.find((obj) => obj.questionTab === currentPage)?.question || "";

    const getTopTpocicsChart = (data, loading, ref, topic) => {
        let nodata = !data || (data && data.formatted_data && data.formatted_data.length === 0);
        let topicName = topic === "topic1" ? "Top topics for own brand" : "Top topics for competitor brand";
        let info =
            topic === "topic1"
                ? "This chart will show you the top topics which mentioned your brand in the past week "
                : "This chart will show you the top topics which mentioned your competitor brand in the past week ";

        return (
            <>
                <div className={`dashboard-widget-container }`} ref={ref}>
                    <div className="dashboard-widget-container-header skiptranslate ocr__owncloud">
                        <ChartName name={topicName} info={info} chatGPT={true} />
                    </div>
                    {loading ? (
                        <div className="no__data__block">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                    ) : !nodata && !loading ? (
                        <div className="dashboard-chart wordcloud-chart skiptranslate top__topics__container">
                            <div className="top__topics">
                                <TopTopicsChart
                                    data={data}
                                    // appliedFilter={this.props.appliedFilter}
                                    // addContextMenuListener={this.addContextMenuListener}
                                    // sentiment={this.state.sentiment}
                                    // showContextMenu={this.showContextMenu}
                                    // showMore={this.props.showMore}

                                    widgetContainerRef={ref}
                                    insights__recommendation
                                />
                            </div>
                        </div>
                    ) : (
                        <>
                            <NoData classname="gpt__no__data" />
                        </>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className={`ocr__wordcloud__wrapper column__flex`}>
                <div className="gptHeader">
                    <div className="top">
                        <div>{question} </div>
                    </div>
                    <div className="lower">{`From date: ${range}`}</div>
                </div>
                {brandTopicObj ? getTopTpocicsChart(topic1Data, topic1DataLoading, widgetContainerRef1, "topic1") : null}
                {competitorTopicObj ? getTopTpocicsChart(topic2Data, topic2DataLoading, widgetContainerRef2, "topic2") : null}
            </div>
        </>
    );
};

export default TopTopics;
